<!-- Edit Mode -->
<tr class="em-c-table__row" *ngIf="!isViewOnly">
  <td class="em-c-table__cell em-js-cell em-js-cell-editable" colspan="">
    <select
      #exeptionSelect
      class="em-c-select"
      (ngModelChange)="
        onExceptionStateSelected(exception.criteria, $event, exeptionSelect)
      "
      (change)="onExceptionSelected($event)"
      [(ngModel)]="exception.criteria"
    >
      <option
        value="New"
        selected
        disabled
        *ngIf="exception.criteria === 'New'"
      >
        New
      </option>
      <option
        *ngFor="let item of exceptionPair; let indexOfelement = index"
        value="{{ item.criteria }}"
      >
        {{ item.criteria }}
      </option>
    </select>
  </td>
  <td class="em-c-table__cell em-js-cell em-js-cell-editable" colspan="">
    <select
      class="em-c-select"
      (change)="onExceptionValueSelected($event)"
      [(ngModel)]="exception.value"
      *ngIf="exception.criteria !== 'Material Exclusion'"
    >
      <option value="New" selected disabled *ngIf="exception.value === 'New'">
        New
      </option>
      <option *ngFor="let item of exceptionValues" value="{{ item }}">
        {{ item }} {{ exception.criteria === "Demand Horizon" ? "Months" : "" }}
      </option>
    </select>
    <material-input
      (input)="onExceptionValueSelected($event)"
      (change)="onExceptionValueSelected($event)"
      (selectedValueChange)="onSelectedValueChange($event)"
      [(selectedValue)]="exception.value"
      *ngIf="exception.criteria === 'Material Exclusion'"
      [error]="error"
    ></material-input>
  </td>
  <td
    class="em-c-table__cell em-js-cell em-js-cell-editable actioncol"
    colspan=""
  >
    <p class="delete-text em-u-clickable" (click)="onDelete($event)">Delete</p>
  </td>
</tr>
<!-- View Mode -->
<tr class="em-c-table__row" *ngIf="isViewOnly">
  <td class="em-c-table__cell em-js-cell em-js-cell-editable" colspan="">
    {{ exception.criteria }}
  </td>
  <td class="em-c-table__cell em-js-cell em-js-cell-editable" colspan="">
    {{ formattedExceptionValue }}
  </td>
</tr>
